import { type EditorPlugin } from '../../types/aha-editor';

export const SharedSnippetBlockSchemaPlugin: EditorPlugin = {
  name: 'Shared Snippet block schema plugin',
  schema: {
    'shared-snippet': {
      isInline: false,
      isVoid: true,
    },
  },
};

export const SharedSnippetInlineSchemaPlugin: EditorPlugin = {
  name: 'Shared Snippet inline schema plugin',
  schema: {
    'shared-snippet-inline': {
      isInline: true,
      isVoid: true,
    },
  },
};
